import { motion } from "framer-motion";
import { Play } from "lucide-react";
import { useLang } from "../../lib/i18n";

const VIDEO_APPART = "https://customer-assets-0z36b82j.emergentagent.net/job_shamar-services/artifacts/cbwmmttm_VIDEO-2026-05-06-16-23-33.mp4";
const VIDEO_BUFFET = "https://customer-assets-0z36b82j.emergentagent.net/job_shamar-services/artifacts/s54hk73z_VIDEO-2026-04-23-13-41-20.mp4";

const fadeUp = {
  hidden: { opacity: 0, y: 50 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, delay: i * 0.15, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const VideosSection = () => {
  const { t } = useLang();
  return (
    <section id="immersion" className="bg-[#FAFAFA] py-24 md:py-32" data-testid="videos-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-2xl mb-16"
        >
          <p className="font-script text-[#C9A03C] text-2xl mb-4">{t.videos.eyebrow}</p>
          <h2 className="font-serif-lux text-3xl sm:text-4xl lg:text-5xl font-medium leading-tight text-logo-gradient pb-1">
            {t.videos.title}
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-12 gap-6">
          <motion.figure
            custom={0}
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-60px" }}
            className="md:col-span-7"
            data-testid="video-apartment"
          >
            <div className="relative overflow-hidden bg-[#050B14]">
              <video src={VIDEO_APPART} controls playsInline preload="metadata" className="w-full aspect-video object-cover" />
            </div>
            <figcaption className="mt-4 flex items-baseline gap-3">
              <Play className="w-4 h-4 text-[#C9A03C] shrink-0 translate-y-0.5" />
              <span className="text-sm text-[#0A192F]/60 font-light tracking-wide">{t.videos.cap1}</span>
            </figcaption>
          </motion.figure>

          <motion.figure
            custom={1}
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-60px" }}
            className="md:col-span-5 md:mt-16"
            data-testid="video-buffet"
          >
            <div className="relative overflow-hidden bg-[#050B14]">
              <video src={VIDEO_BUFFET} controls playsInline preload="metadata" className="w-full aspect-video object-cover" />
            </div>
            <figcaption className="mt-4 flex items-baseline gap-3">
              <Play className="w-4 h-4 text-[#C9A03C] shrink-0 translate-y-0.5" />
              <span className="text-sm text-[#0A192F]/60 font-light tracking-wide">{t.videos.cap2}</span>
            </figcaption>
          </motion.figure>
        </div>
      </div>
    </section>
  );
};
